import Vue from 'vue'
import Vuetify from 'vuetify/lib'
Vue.use(Vuetify)
import '@fortawesome/fontawesome-free/css/all.css'
import hu from 'vuetify/es5/locale/hu'

export default new Vuetify({
  icons: {
    iconfont: 'fa'
  },
  lang: {
  	locales: {hu},
  	current:'hu'
  },
  theme: { dark: true }
})
